// FTR F19 — modal overlay (PDF side panel / Excel viewer)
// Excel: ftr-ledger pattern — viewer has its own X button, no double header
// PDF: full-height side panel sliding in from right

import {Icon} from '@ui/lib/primitive/Icon'
import type {ModalState} from './types'
import {ExcelViewerEmbed} from './ExcelViewerEmbed'
import {S} from './styles'

export function Modal({modal, onClose}: {
	modal: NonNullable<ModalState>
	onClose: () => void
}) {
	if (modal.type === 'excel') {
		return (
			<div style={S.modalOverlay} onClick={onClose}>
				<div style={S.excelModal} onClick={e => e.stopPropagation()}>
					<ExcelViewerEmbed buffer={modal.buffer} filename={modal.filename} sheetIndex={modal.sheetIndex} highlight={modal.highlight} onClose={onClose} />
				</div>
			</div>
		)
	}

	// PDF: side panel from right
	return (
		<div style={S.modalOverlay} onClick={onClose}>
			<div style={S.pdfPanel} onClick={e => e.stopPropagation()}>
				<div style={S.pdfPanelHeader}>
					<span style={S.pdfPanelTitle}>{modal.short}.pdf</span>
					<button style={S.iconBtn} onClick={onClose}><Icon icon="tabler:x" size={18} /></button>
				</div>
				<iframe src={modal.url} style={S.pdfFrame} />
			</div>
		</div>
	)
}
